export const getTransformedHtml = (html) => {
  let newHtml = null;
  const re = /Escuchar la grabación: <a[\s]+href="(?<target>.*?)"[^>]*>(?<text>.*?)<\/a>/g;
  const match = re.exec(html);
  if (match !== null) {
    const lastAperance = html.lastIndexOf(match?.groups?.text);
    newHtml = html.slice(0, lastAperance) + html.slice(lastAperance).replace(match?.groups?.text, 'Audio');
  }
  return newHtml || html;
};
